import { Grid } from "@mui/material";
import React from "react";
import { HeaderForm } from "./LoginStyled";
import { ImageController } from "../../Layouts/ImageController";
import LoginForm from "./LoginForm";
import LoginAnimation from "../../Components/LottieAnimation/LoginAnimation";
import Logo from "../../Assets/logo.png";

const Login = () => {
  return (
    <>
      <Grid
        container
        columns={12}
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{ height: "100vh" }}
      >
        <Grid
          item
          md={6}
          xs={12}
          className="center-flex"
          sx={{ sm: "block", display: { xs: "none", md: "flex" } }}
        >
          <LoginAnimation />
        </Grid>
        <Grid item md={6} xs={12}>
          <HeaderForm>
            <ImageController
              src={Logo}
              width="250px"
              objectFit="cover"
              drop="0px 3px 5px #8d8d8d"
              m="-2rem 0  2rem "
            />
            <h2>Login </h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic,
              odit.
            </p>
            <LoginForm />
          </HeaderForm>
        </Grid>
      </Grid>
    </>
  );
};

export default Login;
